import { render, staticRenderFns } from "./employeesStatement.vue?vue&type=template&id=78a42b36"
import script from "./employeesStatement.vue?vue&type=script&lang=js"
export * from "./employeesStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports